import { useMemo } from 'react';
import DOMPurify from 'dompurify';
import parse from 'html-react-parser';

// eslint-disable-next-line i18next/no-literal-string
const allowedTags = ['p', 'ul', 'ol', 'li', 'b', 'strong', 'i', 'em', 'br', 'h3', 'h4', 'h5', 'h6', 'img', 'a', 'span'];
// eslint-disable-next-line i18next/no-literal-string
const allowedAttributes = ['src', 'alt', 'width', 'height', 'href'];

const RichTextLabel = ({ html }: { html: string }) => {
  const safeHtml = useMemo(
    () =>
      DOMPurify.sanitize(html, {
        ALLOWED_TAGS: allowedTags,
        ALLOWED_ATTR: allowedAttributes
      }),
    [html]
  );

  const parsedDom = useMemo(() => parse(safeHtml), [safeHtml]);

  return parsedDom;
};

export default RichTextLabel;
